module.exports = __webpack_public_path__ + "static/media/allow.54916f4f.png";